/*
 * @Author: 四川华西绿舍建材有限公司
 * @Date: 2022-02-23 10:50:10
 * @LastEditors: hexy
 * @LastEditTime: 2024-01-08 09:48:31
 * @Description: 
 * @FilePath: \ICPSxin\src\api\smart\mix.js
 */
import request from "@/utils/request";
export const queryPage = "/icps/system/sign/intelligent/workMixRatio/queryPage";
/*获取强度等级和性能要求等。。。*/
export function getLists(data) {
  return request({
    url: "/icps/system/sign/basics/namingRule/getLists",
    method: "post",
    data,
  });
}
/*获取配合比列表*/
export function getMixList(data) {
  return request({
    url: "/icps/system/sign/intelligent/workMixRatio/queryPage",
    method: "post",
    data,
  });
}
/*获取工程列表*/
export function engineeringManagementQueryPage(data) {
  return request({
    url: "/icps/system/sign/cloudSell/engineeringManagement/QueryPage",
    method: "post",
    data,
  });
}
/*获取工程列表*/
export function getProjectByCompanyId(params) {
  return request({
    url: "/icps/system/sign/cloudSell/engineeringManagement/getProjectByCompanyId",
    method: "get",
    params,
  });
}
/*获取详情*/
export function getRatioDetail(data) {
  return request({
    url: "/icps/system/sign/intelligent/workMixRatio/getRatioDetail",
    method: "post",
    data,
  });
}
/*保存*/
export function saveOrUpdate(data) {
  return request({
    url: "/icps/system/sign/intelligent/workMixRatio/saveOrUpdate",
    method: "post",
    data,
  });
}